/**
 * 在地图已销毁或容器已卸载时安全跳过 resize，避免
 * "Cannot set properties of undefined (setting 'width')"
 */
export function safeMapResize(map) {
  try {
    if (!map || map._removed) return false;
    if (typeof map.getCanvas !== 'function' || !map.getCanvas()) return false;
    const container = typeof map.getContainer === 'function' ? map.getContainer() : null;
    if (!container || !container.isConnected) return false;
    if (typeof map.resize !== 'function') return false;
    map.resize();
    return true;
  } catch (_) {
    return false;
  }
}

/** 判断地图实例是否仍可安全调用 getLayer / getSource 等 */
export function isMapAlive(map) {
  try {
    if (!map || map._removed) return false;
    if (typeof map.getStyle !== 'function') return false;
    return !!map.getStyle();
  } catch (_) {
    return false;
  }
}
